import OpacityIcon from "@mui/icons-material/Opacity";
import OpacityOutlinedIcon from "@mui/icons-material/OpacityOutlined";
import OpacityTwoToneIcon from "@mui/icons-material/OpacityTwoTone";
import { Chip, Stack, Typography } from "@mui/material";
import { useState } from "react";

const FilterWater = ({ onChange, value }) => {
  const [selected, setSelected] = useState(value);

  const handleClick = (level) => {
    if (selected.includes(level)) {
      setSelected(selected.filter((item) => item !== level));
    } else {
      setSelected([...selected, level]);
    }

    onChange(selected);
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Water Level
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        <Chip
          icon={<OpacityIcon />}
          label="High"
          clickable
          color={selected.includes("high") ? "primary" : "default"}
          onClick={() => handleClick("high")}
        />
        <Chip
          icon={<OpacityTwoToneIcon />}
          label="Medium"
          clickable
          color={selected.includes("medium") ? "primary" : "default"}
          onClick={() => handleClick("medium")}
        />
        <Chip
          icon={<OpacityOutlinedIcon />}
          label="Low"
          clickable
          color={selected.includes("low") ? "primary" : "default"}
          onClick={() => handleClick("low")}
        />
      </Stack>
    </>
  );
};

export default FilterWater;
